module.exports = __webpack_public_path__ + "img/fail.e330bff7.png";